function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic /2/ Linkedin");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "News",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-/-News-Detail",
  transform: "translate(-158.000000, -446.000000)",
  fill: "#004E44"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(152.000000, 440.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_Linkedin",
  transform: "translate(6.666667, 6.666667)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.7,9.34040172e-17 L1.96666667,9.34040172e-17 C1.45104116,-0.00890992718 0.953225755,0.18855287 0.583904492,0.548484609 C0.214583229,0.908416348 0.00436873575,1.40098269 0,1.91666667 L0,24.75 C0.00436873575,25.265684 0.214583229,25.7582503 0.583904492,26.1181821 C0.953225755,26.4781138 1.45104116,26.6755766 1.96666667,26.6666667 L24.7,26.6666667 C25.2156255,26.6755766 25.7134409,26.4781138 26.0827622,26.1181821 C26.4520834,25.7582503 26.6622979,25.265684 26.6666667,24.75 L26.6666667,1.91666667 C26.6622979,1.40098269 26.4520834,0.908416348 26.0827622,0.548484609 C25.7134409,0.18855287 25.2156255,-0.00890992718 24.7,9.34040172e-17 Z M7.9,22.7333333 L3.95,22.7333333 L3.95,10 L7.9,10 L7.9,22.7333333 Z M5.93333333,8.33333333 C4.66974568,8.34195819 3.63583692,7.32958421 3.61786719,6.06609491 C3.59989745,4.8026056 4.60459728,3.76123791 5.86791913,3.73392428 C7.13124098,3.70661066 8.18001065,4.70358137 8.21666667,5.96666667 C8.23930537,6.58655005 8.00877225,7.18896687 7.57808594,7.63537165 C7.14739964,8.08177643 6.55362984,8.33374659 5.93333333,8.33333333 L5.93333333,8.33333333 Z M22.7333333,22.8166667 L18.7666667,22.8166667 L18.7666667,16.5333333 C18.7666667,15.0666667 18.7666667,13.2 16.7166667,13.2 C14.6666667,13.2 14.35,14.8666667 14.35,16.5333333 L14.35,22.8333333 L10.3833333,22.8333333 L10.3833333,10 L14.1833333,10 L14.1833333,11.6666667 L14.1833333,11.6666667 C14.9610118,10.3454886 16.4013857,9.55808418 17.9333333,9.61666667 C21.9333333,9.61666667 22.6833333,12.25 22.6833333,15.6833333 L22.7333333,22.8166667 Z",
  id: "Shape"
})))));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.e43dab82.svg";
export { ForwardRef as ReactComponent };